import { useQuery } from '@tanstack/react-query'
import { Table, Input, Select, Button } from 'antd'
import { get } from 'lodash'
import { RefreshCcw } from 'lucide-react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Layout from '@components/Layout/index'
import { debouncedSet } from '@utils/debounce'


import '../../index.css'
import { downloadExcel } from '@utils/downloadPdf'
import {
	fetchWarehouse,
	fetchReports,
	fetchReportsWithWhs,
} from '@utils/fetchData'


import ExcelButton from '../../components/ExcelButton/index'

const Reports = () => {
	const { getMe } = useSelector((state) => state.main)
	const { t } = useTranslation()
	const role = get(getMe, 'jobTitle', '')

	const [currentPage, setCurrentPage] = useState(0)
	const [itemName, setItemName] = useState('')
	const [warehouse, setWarehouse] = useState('')
	const [whsName, setWhsName] = useState('')
	const [loadingExcel, setLoadingExcel] = useState(false)

	const { data: warehouseData = [] } = useQuery({
		queryKey: ['warehouses'],
		queryFn: fetchWarehouse,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: reportsData = [], isLoading, refetch } = useQuery({
		queryKey: ['reports', currentPage, itemName],

		queryFn: fetchReports,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: reportsDataWithWhs = [], isLoading: reportsWithWhsLoading,refetch: refetchWithWhs } =
		useQuery({
			queryKey: ['reportsWithWhs', currentPage, itemName, warehouse],

			queryFn: fetchReportsWithWhs,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			enabled: warehouse !== '',
		})
	const handleItemNameChange = (val) => {
		debouncedSet(val, setItemName)
	}

	const columns = [
		{
			title: '',
			children: [
				{
					title: t('item'),
					dataIndex: 'itemName',
					key: 'itemName',
					width: 300,
					fixed: 'left',
					render: (text) => <div className="sticky-cell" style={{ whiteSpace: 'pre-wrap' }}>{text}</div>,
				},
			],
		},
		// {
		// 	title: '',
		// 	children: [
		// 		{
		// 			title: t('available'),
		// 			dataIndex: 'available',
		// 			key: 'available',

		// 			render: (text, record) => {
		// 				const warehouseInfo = record.inventoryItemWhs[0]
		// 				const onHand = warehouseInfo
		// 					? warehouseInfo.available
		// 					: '0'
		// 				const formattedonHand = new Intl.NumberFormat(
		// 					'fr-FR',
		// 				).format(onHand)
		// 				return (
		// 					<div className="flex items-center justify-center w-full">
		// 						{formattedonHand}
		// 					</div>
		// 				)
		// 			},
		// 		},
		// 	],
		// },

		{
			title: '',
			children: [
				{
					title: t('quantityReport'),
					dataIndex: 'onHandSum',
					key: 'onHandSum',

					render: (text) => {
						const formattedText = new Intl.NumberFormat(
							'fr-FR',
						).format(text)
						return (
							<div className="flex items-center justify-center w-full">
								{formattedText}
							</div>
						)
					},
				},
			],
		},

		...warehouseData.map((item) => ({
			title: '',
			children: [
				{
					title: `${item.name} (${t('ordered')})`,
					dataIndex: `${item.code}_onHand`,
					key: `${item.code}_onHand`,
					render: (text, record) => {
						const warehouseInfo = record.inventoryItemWhs.find(
							(w) => w.warehouseName === item.name,
						)
						const onHand = warehouseInfo
							? warehouseInfo.onOrder
							: '0'
						const formattedOnHand = new Intl.NumberFormat(
							'fr-FR',
						).format(onHand)
						return (
							<div className="flex items-center justify-center w-full">
								{formattedOnHand}
							</div>
						)
					},
				},
				{
					title: `${item.name} (${t('available')})`,
					dataIndex: `${item.code}_available`,
					key: `${item.code}_available`,
					render: (text, record) => {
						const warehouseInfo = record.inventoryItemWhs.find(
							(w) => w.warehouseName === item.name,
						)
						const onHand = warehouseInfo
							? warehouseInfo.onHand
							: '0'
						const formattedOnHand = new Intl.NumberFormat(
							'fr-FR',
						).format(onHand)
						return (
							<div className="flex items-center justify-center w-full">
								{formattedOnHand}
							</div>
						)
					},
				},
				{
					title: `${item.name} (${t('Зарезервировано')})`,
					dataIndex: `${item.code}_isCommited`,
					key: `${item.code}_isCommited`,
					render: (text, record) => {
						const warehouseInfo = record.inventoryItemWhs.find(
							(w) => w.warehouseName === item.name,
						)
						console.log(warehouseInfo)
						const onHand = warehouseInfo
							? warehouseInfo.isCommited
							: '0'
						const formattedOnHand = new Intl.NumberFormat(
							'fr-FR',
						).format(onHand)
						return (
							<div className="flex items-center justify-center w-full">
								{formattedOnHand}
							</div>
						)
					},
					width: '200',
				},
			],
		})),
	]

	const columnsWithWhs = [
		{
			title: '',
			children: [
				{
					title: t('item'),
					dataIndex: 'itemName',
					key: 'itemName',
					width: 300,
					fixed: 'left',
					render: (text) => <b style={{ whiteSpace: 'pre-wrap' }}>{text}</b>,
				},
			],
		},

		{
			title: '',
			children: [
				{
					title: t('quantityReport'),
					dataIndex: 'onHand',
					key: 'onHand',

					render: (text) => {
						const formattedText = new Intl.NumberFormat(
							'fr-FR',
						).format(text)
						return (
							<div className="w-full flex items-center justify-center">
								{formattedText}
							</div>
						)
					},
				},
			],
		},
		{
			title: '',
			children: [
				{
					title: t('inProductionQty'),
					dataIndex: 'inProductionQty',
					key: 'inProductionQty',

					render: (text, record) => {
						const formattedonHand = new Intl.NumberFormat(
							'fr-FR',
						).format(text)
						return (
							<div className="w-full flex items-center justify-center">
								{formattedonHand}
							</div>
						)
					},
				},
			],
		},

		{
			title: '',
			children: [
				{
					title: t('leftover'),
					key: 'leftover',
					render: (_, record) => {
						const formattedonHand = new Intl.NumberFormat(
							'fr-FR',
						).format(record.onHand - record.inProductionQty)
						return (
							<div className="w-full flex items-center justify-center">
								{formattedonHand}
							</div>
						)
					},
				},
			],
		},
		{
			title: '',
			children: [
				{
					title: t('onOrder'),
					dataIndex: 'onOrder',
					key: 'onOrder',

					render: (text, record) => {
						const formattedonHand = new Intl.NumberFormat(
							'fr-FR',
						).format(text)
						return (
							<div className="w-full flex items-center justify-center">
								{formattedonHand}
							</div>
						)
					},
				},
			],
		},
		// {
		// 	title: '',
		// 	children: [
		// 		{
		// 			title: t('available'),
		// 			dataIndex: 'available',
		// 			key: 'available',

		// 			render: (text, record) => {
		// 				const formattedonHand = new Intl.NumberFormat(
		// 					'fr-FR',
		// 				).format(text)
		// 				return (
		// 					<div className="w-full flex items-center justify-center">
		// 						{formattedonHand}
		// 					</div>
		// 				)
		// 			},
		// 		},
		// 	],
		// },

		{
			title: '',
			children: [
				{
					title: t('whs'),
					dataIndex: 'whsName',
					key: 'whsName',

					render: (text) => {
						return <span>{whsName}</span>
					},
				},
			],
		},
	]

	const handleNextPage = () => {
		setCurrentPage((prevPage) => prevPage + 1)
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-inventory-items',
			params: {
				itemName: itemName,
				pageToken: 0,
				pageSize: 1000,
			},
			fileName: 'Ombor qoldiqlari',
			onLoadingChange: setLoadingExcel,
		})
	}

	return (
		<Layout>
			<div className="m-5 border-[2px] border-gray-200">
				<div className=" flex items-center justify-between ml-4  mr-4 sm:mr-10 mt-10  sm:ml-10 sm:mt-14">
					<h1 className="font-poppins  text-xl font-bold text-black sm:text-2xl">
						{t('reportsWhs')}
					</h1>
					<div className="flex items-center gap-2">
								<Button
						type="primary"
						className="w-[130px] bg-[#0A4D68]  rounded-lg text-white"
						onClick={() => {
							refetch()
							setCurrentPage(0)
							refetchWithWhs()
						}}
					>
						<div className="flex items-center gap-2">
							<RefreshCcw size={16} />
							<span>{t('refetch')}</span>
						</div>
					</Button>
					<ExcelButton
						handleDownloadExcel={handleDownloadExcel}
						loadingExcel={loadingExcel}
					/>
					</div>
				</div>

				<div className="mt-6 sm:ml-10 sm:mt-10">
					<div className="mb-4 flex flex-col justify-between sm:flex-row">
						<div className="flex items-center gap-5">
							{role === 'admin' ? (
								<div className="flex flex-col gap-2">
									<p>{t('whs')}</p>
									<Select
										value={warehouse}
										onChange={(value, label) => {
											setWhsName(label?.label)
											setWarehouse(value)
											console.log(value)
										}}
										allowClear
										showSearch
										filterOption={(input, option) =>
											option.label
												.toLowerCase()
												.includes(input.toLowerCase())
										}
										className="w-full sm:w-[200px] h-8"
										options={warehouseData.map((whs) => {
											return {
												label: whs.name,
												value: whs.code,
											}
										})}
									/>
								</div>
							) : (
								<div></div>
							)}
							<div className="flex flex-col gap-2">
								<p>{t('item')}</p>
								<Input
									placeholder={t('item')}
									onChange={(e) =>
										handleItemNameChange(e.target.value)
									}
									className="w-full sm:w-[250px]"
								/>
							</div>
						</div>

						<div className="mt-2 flex sm:mr-10">
							<button
								onClick={handlePreviousPage}
								disabled={currentPage === 0}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('previous')}
							</button>
							<div className="bg-[#099204]  w-[20px] h-[30px] flex items-center  justify-center">
								<span className="text-center text-white">
									{currentPage + 1}
								</span>
							</div>
							<button
								onClick={handleNextPage}
								disabled={
									warehouse
										? reportsDataWithWhs?.[0]?.items
												.length !== 30
										: reportsData.length !== 30
								}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('next')}
							</button>
						</div>
					</div>
				</div>

				<div className="mt-10 w-full border-[1px] border-[#E8E8E8] sm:mt-14"></div>

				<div className="ml-10">
					<Table
						columns={warehouse ? columnsWithWhs : columns}
						dataSource={
							warehouse
								? reportsDataWithWhs?.[0]?.items
								: reportsData
						}
						pagination={false}
						className="mt-6 w-full sm:mt-10 my-custom-table "
						rowKey="zakaz"
						bordered
						scroll={{ x: warehouse ? 1200 : 3500 }}
						sticky={true}
						loading={isLoading || reportsWithWhsLoading}
					/>
				</div>
			</div>
		</Layout>
	)
}

export default Reports
